import { render, staticRenderFns } from "./CourseSingleForm.vue?vue&type=template&id=3aac55bd&scoped=true&"
import script from "./CourseSingleForm.vue?vue&type=script&lang=js&"
export * from "./CourseSingleForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseSingleForm.vue?vue&type=style&index=0&id=3aac55bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac55bd",
  null
  
)

export default component.exports